<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card card-top-line">
          <div class="header">
            <h2>Customer IP Blacklist</h2>
          </div>
          <div class="body pt-0">
            <div class="chart-top-action d-lg-flex justify-content-end mb-1">
              <div class="fliter-main mr-auto mt-3 mt-md-0">
                <b-button
                  class="fliter-btn btn-lg btn-mw"
                  :variant="isVisibleFilter ? 'primary' : 'outline-primary'"
                  @click="openFilters()"
                >
                  Filters
                  <i class="fa fa-filter" aria-hidden="true"></i>
                </b-button>
              </div>
              <div
                class="d-md-flex justify-content-between mt-lg-0 mt-md-3 mt-0"
              >
                <div
                  class="payment-dropdown d-flex flex-row-reverse ml-lg-3 mt-3 mt-sm-0"
                >
                  <b-button
                    size="lg"
                    variant="primary btn-mw"
                    @click="addNew()"
                  >
                    Add New
                    <i class="fa fa-plus-square"></i>
                  </b-button>
                </div>
              </div>
              <b-collapse
                id="fliter-collapse"
                class="fliter-collapse"
                v-model="isVisibleFilter"
              >
                <div
                  class="d-flex flex-column justify-content-between pt-3 pr-3 pl-3 middleware-list-wrapper"
                >
                  <div
                    v-for="(item, index) in advanceFilters"
                    :key="index"
                    class="d-flex middleware-list"
                  >
                    <div
                      class="form-group form-select single-multiselect m-0 column-1"
                    >
                      <span class="float-label w-100">
                        <label>Select Field</label>
                        <multiselect
                          placeholder=""
                          v-model="item.field"
                          :show-labels="false"
                          :options="filterField"
                          label="name"
                          :searchable="true"
                          :allowEmpty="false"
                          @select="fieldsUpdate"
                        ></multiselect>
                      </span>
                      <div class="line"></div>
                    </div>
                    <div
                      class="form-group m-0 column-2"
                      v-if="item.field.id == 'customer'"
                    >
                      <input
                        class="form-control"
                        type="text"
                        v-model="item.search"
                        placeholder="Enter Payinc ID / Customer Name / Email Address / Phone Number"
                      />
                      <div class="line"></div>
                    </div>
                    <div class="form-group m-0 column-2" v-else>
                      <input
                        class="form-control"
                        type="text"
                        v-model="item.search"
                        :placeholder="'Enter ' + item.field.name"
                      />
                      <div class="line"></div>
                    </div>
                    <div v-if="advanceFilters.length > 1" class="column-3">
                      <b-button
                        class="fliter-btn btn-lg"
                        variant="outline-danger"
                        @click="removeFilter(index)"
                      >
                        <i class="fa fa-times" aria-hidden="true"></i>
                      </b-button>
                    </div>
                  </div>
                  <div class="text-left">
                    <b-button
                      class="fliter-btn w-auto"
                      variant="outline-primary"
                      @click="appendFilter"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i>
                      Add more filters
                    </b-button>
                  </div>
                </div>
                <div class="pb-3 pr-3 text-right">
                  <button
                    class="btn btn-primary w-auto"
                    @click="applyTestfilter"
                  >
                    Apply
                  </button>
                  <button
                    class="btn btn-outline-danger w-auto ml-3"
                    @click="clearTestfilter"
                  >
                    Cancel/Clear
                  </button>
                </div>
              </b-collapse>
            </div>
            <div
              class="filter-list-area d-flex flex-wrap align-items-center mb-1"
              v-if="displayFilters && displayFilters.length > 0"
            >
              <i
                class="fa fa-filter text-primary mr-1 mb-2"
                aria-hidden="true"
              ></i>
              <div
                class="mb-1"
                v-for="(item, index) in displayFilters"
                :key="index"
              >
                <label
                  class="font-14 line-height-18 mb-0 ml-2"
                  v-if="
                    index == 0 ||
                    item.filter_field != displayFilters[index - 1].filter_field
                  "
                >
                  {{ item.field_name + ":" }}
                </label>
                <!-- Other filter -->
                <span class="badge badge-warning-solid">
                  {{ item.filter_value ? item.filter_value : "-" }}
                  <i
                    class="fa fa-close cursor-pointer ml-1"
                    @click="removeFilter(index)"
                  ></i>
                </span>
              </div>
              <span class="text-danger cursor-pointer" @click="clearTestfilter">
                Clear all
              </span>
            </div>
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <b-table
              ref="partnertable"
              responsive
              hover
              table-class="js-basic-example table-custom mb-0 border"
              head-variant="light"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              striped
            >
              <template #cell(country)="data">
                <div class="align-items-center d-flex">
                  <span :class="data.value.flagClass"></span>
                  <span
                    class="ml-2"
                    v-b-tooltip.hover
                    :title="data.item.country.name"
                  >
                    {{ data.item.country.isocode.toUpperCase() }}
                  </span>
                </div>
              </template>
              <template #cell(name)="data">
                <span>
                  <a
                    href="javascript:void(0);"
                    class="font-color"
                    @click="customerDetailModel(data.item)"
                    v-if="data.value"
                  >
                    {{ data.value }}
                  </a>
                  <span v-else>--</span>
                  <a
                    href="javascript:void(0);"
                    class="cursor-pointer"
                    @click="opencustomerModel()"
                    v-if="data.index == 6"
                  >
                    +{{ moreCustomerlist.length - 1 }}
                  </a>
                </span>
              </template>
              <template #cell(action)>
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  right
                  variant="outline-primary"
                >
                  <b-dropdown-item @click="edit()">Edit</b-dropdown-item>
                  <b-dropdown-item @click="showAlert">
                    Whitelist / Unblock
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <b-modal
              id="customer-list"
              size="lg"
              title="Customer Details"
              no-stacking
              no-close-on-backdrop
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Blacklisted Customer List
                </h5>
              </template>
              <div class="modal-area">
                <b-table
                  ref="partnertable"
                  responsive
                  hover
                  head-variant="light"
                  :items="moreCustomerlist"
                  :fields="moreCustomerfields"
                  striped
                >
                  <template #cell(country)="data">
                    <div class="align-items-center d-flex">
                      <span :class="data.value.flagClass"></span>
                      <span
                        class="ml-2"
                        v-b-tooltip.hover
                        :title="data.item.country.name"
                      >
                        {{ data.item.country.isocode.toUpperCase() }}
                      </span>
                    </div>
                  </template>
                  <template #cell(name)="data">
                    <a
                      href="javascript:void(0);"
                      class="font-color"
                      @click="customerDetailModel(data.item)"
                    >
                      {{ data.value }}
                    </a>
                  </template>
                </b-table>
              </div>
              <template #modal-footer>
                <b-button
                  size="sm"
                  variant="secondary"
                  @click="$bvModal.hide('customer-list')"
                >
                  Cancel
                </b-button>
              </template>
            </b-modal>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CustomerDetailsModel :customerDetail="customerDetail" />
    <main-loader :loading="isLoading"></main-loader>
  </div>
</template>
<script>
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
import { GET_CUSTOMER_DETAILS } from "../../../store/actions.type.js";
import CustomerDetailsModel from "../../core/CustomerDetailsModel.vue";
import { mapGetters } from "vuex";
export default {
  name: "CustomerIPBlacklist",
  components: {
    BreadCrumb,
    Multiselect: () => import("vue-multiselect"),
    "main-loader": LoaderComponent,
    CustomerDetailsModel,
  },
  data() {
    return {
      customerDetail: null,
      items: [
        {
          country: {
            flagClass: "flag-icon flag-icon-gb fi-lg fi-round",
            isocode: "gb",
            name: "United Kingdom",
          },
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          name: "Robert Evans",
          email: "robert21@hotmail.com",
          mobile: "+447799691752",
          regdate: "2019-07-09 15:04:00",
          ipaddress: "192.168.1.148:8080(test)",
          action: "",
        },
        {
          country: {
            flagClass: "flag-icon flag-icon-gh fi-lg fi-round",
            isocode: "gh",
            name: "Ghana",
          },
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          name: "Selena Parker",
          email: "selena3@f2b.com.br",
          mobile: "+233263456785",
          regdate: "2019-07-09 15:04:00",
          ipaddress: "192.168.1.148:8080(test)",
          action: "",
        },
        {
          country: {
            flagClass: "flag-icon flag-icon-us fi-lg fi-round",
            isocode: "us",
            name: "United States",
          },
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          name: "",
          email: "--",
          mobile: "--",
          regdate: "2019-07-09 15:04:00",
          ipaddress: "192.168.1.148:8080(test)",
          action: "",
        },
        {
          country: {
            flagClass: "flag-icon flag-icon-gb fi-lg fi-round",
            isocode: "gb",
            name: "United Kingdom",
          },
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          name: "",
          email: "--",
          mobile: "--",
          regdate: "2019-07-09 15:04:00",
          ipaddress: "192.168.1.148:8080(test)",
          action: "",
        },
        {
          country: {
            flagClass: "flag-icon flag-icon-us fi-lg fi-round",
            isocode: "us",
            name: "United States",
          },
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          name: "Hal Chalamet",
          email: "hal@hotmail.com",
          mobile: "+447799691752",
          regdate: "2019-07-09 15:04:00",
          ipaddress: "--",
          action: "",
        },
        {
          country: {
            flagClass: "flag-icon flag-icon-gb fi-lg fi-round",
            isocode: "gb",
            name: "United Kingdom",
          },
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          name: "Ben Murphy",
          email: "benm@test.com.br",
          mobile: "+233263456785",
          regdate: "2019-07-09 15:04:00",
          ipaddress: "--",
          action: "",
        },
        {
          country: {
            flagClass: "flag-icon flag-icon-gb fi-lg fi-round",
            isocode: "gb",
            name: "United Kingdom",
          },
          name: "Emma Thomas",
          email: "emat@f2b.com.br",
          mobile: "+233263456785",
          regdate: "2019-07-09 15:04:00",
          ipaddress: "192.168.1.148:8080(test)",
          action: "",
        },
      ],
      moreCustomerlist: [
        {
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          country: {
            flagClass: "flag-icon flag-icon-gb fi-lg fi-round",
            isocode: "gb",
            name: "United Kingdom",
          },
          name: "Robert Evans",
          email: "robert21@hotmail.com",
          mobile: "+447799691752",
          regdate: "2019-07-09 15:04:00",
        },
        {
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          country: {
            flagClass: "flag-icon flag-icon-us fi-lg fi-round",
            isocode: "us",
            name: "United States",
          },
          name: "Hal Chalamet",
          email: "hal@hotmail.com",
          mobile: "+447799691752",
          regdate: "2019-07-09 15:04:00",
        },
        {
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          country: {
            flagClass: "flag-icon flag-icon-gb fi-lg fi-round",
            isocode: "gb",
            name: "United Kingdom",
          },
          name: "Ben Murphy",
          email: "benm@test.com.br",
          mobile: "+233263456785",
          regdate: "2019-07-09 15:04:00",
        },
        {
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          country: {
            flagClass: "flag-icon flag-icon-gb fi-lg fi-round",
            isocode: "gb",
            name: "United Kingdom",
          },
          name: "Emma Thomas",
          email: "emat@f2b.com.br",
          mobile: "+233263456785",
          regdate: "2019-07-09 15:04:00",
        },
      ],
      moreCustomerfields: [
        {
          key: "country",
          label: "Country",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "name",
          label: "Customer Name",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "email",
          label: "Email",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "mobile",
          label: "Mobile",
          sortable: false,
          thClass: "th_sortfix",
        },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],
      fields: [
        {
          key: "country",
          label: "Country",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "name",
          label: "Customer Name",
          sortable: false,
          thClass: "th_sortfix",
        },
        { key: "ipaddress", label: "Ip Address" },
        {
          key: "email",
          label: "Email",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "mobile",
          label: "Mobile",
          sortable: false,
          thClass: "th_sortfix",
        },
        { key: "action", label: "Action" },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],
      isVisibleFilter: false,
      displayFilters: [],
      filterField: [
        { id: "customer", name: "Customer", $isDisabled: false },
        { id: "ipaddress", name: "Ip Address", $isDisabled: false },
      ],
      advanceFilters: [
        {
          field: { id: "customer", name: "Customer", $isDisabled: false },
          search: "",
        },
      ],
      totalRows: 0,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, { value: 100, text: 100 }],
    };
  },
  methods: {
    // customerDetail
    customerDetailModel(item) {
      this.$store.dispatch(GET_CUSTOMER_DETAILS, item.id).then((response) => {
        if (response.status == 200) {
          const customerdetails = response.data;
          this.$bvModal.show("customer-details");
          this.customerDetail = customerdetails;
        }
      });
    },
    // for openFilters
    openFilters() {
      if (this.advanceFilters == 0) {
        this.advanceFilters = [
          {
            field: { id: "customer", name: "Customer", $isDisabled: false },
            search: "",
          },
        ];
      }
      this.isVisibleFilter = !this.isVisibleFilter;
    },
    // apply filter
    applyTestfilter() {
      let params = [];
      this.advanceFilters.map((item) => {
        let data = {
          filter_field: item.field.id,
          field_name: item.field.name,
          filter_value: item.search,
        };
        params.push(data);
      });
      this.isVisibleFilter = false;
      this.$cookies.set("ip-blacklist-filter", params);
      this.displayFilters = this.$cookies.get("ip-blacklist-filter");
      console.log("params", params);
    },
    // clear filter
    clearTestfilter() {
      this.advanceFilters = [
        {
          field: { id: "customer", name: "Customer", $isDisabled: false },
          search: "",
        },
      ];
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.displayFilters = [];
      this.isVisibleFilter = false;
      this.$cookies.set("ip-blacklist-filter", this.displayFilters);
    },
    // append filters
    appendFilter() {
      this.advanceFilters.map((item) => {
        this.filterField.filter(
          (data) => data.id == item.field.id,
        )[0].$isDisabled = true;
      });
      if (this.filterField.filter((data) => data.$isDisabled == false)[0]) {
        this.advanceFilters.push({
          field: this.filterField.filter(
            (data) => data.$isDisabled == false,
          )[0],
          search: "",
        });
        this.filterField.filter(
          (data) => data.$isDisabled == false,
        )[0].$isDisabled = true;
      }
    },
    // update fields of filters
    fieldsUpdate() {
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.advanceFilters.map((item) => {
        this.filterField.filter(
          (data) => data.id == item.field.id,
        )[0].$isDisabled = true;
      });
    },
    // to remove filters
    removeFilter(index) {
      this.filterField.filter(
        (data) => data.id == this.advanceFilters[index].field.id,
      )[0].$isDisabled = false;
      this.advanceFilters.splice(index, 1);
      this.displayFilters.splice(index, 1);
      this.$cookies.set("ip-blacklist-filter", this.displayFilters);
    },
    cookieFilters() {
      this.displayFilters = this.$cookies.get("ip-blacklist-filter");
      let filters = [];
      if (this.displayFilters && this.displayFilters.length > 0) {
        this.displayFilters.map((item) => {
          this.filterField.filter(
            (data) => data.id == item.filter_field,
          )[0].$isDisabled = true;
          filters.push({
            field: {
              id: item.filter_field,
              name: this.filterField.filter(
                (data) => data.id == item.filter_field,
              )[0].name,
              $isDisabled: true,
            },
            search: item.filter_value,
          });
        });
        this.advanceFilters = filters;
      }
    },
    addNew() {
      this.$router.push({ path: "customer-ip-blacklist/add" });
    },
    edit() {
      this.$router.push({ path: "customer-ip-blacklist/edit" });
    },
    opencustomerModel() {
      this.$bvModal.show("customer-list");
    },
    onChange(event, index) {
      var classVar = "";
      return this.items.map((item, i) => {
        if (index == i + 1) {
          if (event.target.value == "accept") {
            classVar = "btn-outline-success";
          } else if (event.target.value == "cancel") {
            classVar = "btn-outline-danger";
          }
          item.dropdawn.class = classVar;
        }
      });
    },

    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = e.target.value;
        }
      }
    },

    showAlert() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to whitelist?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, whitelist it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire({
              title: "Whitelisted!",
              icon: "success",
            });
          }
        });
    },
  },
  mounted() {
    this.totalRows = this.items.length;
    setTimeout(() => {
      this.cookieFilters();
    }, 100);
  },
  computed: {
    ...mapGetters(["isLoading"]),
  },
};
</script>
